import React from 'react'
import { Spin, Empty, Icon } from 'antd'
import OutfitCard from './OutfitCard'
import './OutfitGrid.scss'

/**
 * Grid layout container for outfit cards
 *
 * @param {Object} props
 * @param {Array} props.outfits - List of outfits
 * @param {Function} props.onItemClick - Item click handler
 * @param {Boolean} props.isLoading - Show loading spinner
 * @param {String} props.emptyMessage - Empty state message
 * @param {Boolean} props.showDelete - Show delete button on cards
 * @param {Function} props.onDelete - Delete handler for cards
 */
const OutfitGrid = ({
  outfits = [],
  onItemClick,
  isLoading = false,
  emptyMessage = 'No outfits found',
  showDelete = false,
  onDelete,
  selectedId = null
}) => {
  if (isLoading) {
    return (
      <div className="outfit-grid-loading">
        <Spin size="large" tip="Loading outfits..." />
      </div>
    )
  }

  if (!outfits || outfits.length === 0) {
    return (
      <div className="outfit-grid-empty">
        <Icon type="skin" className="empty-icon" />
        <p>{emptyMessage}</p>
      </div>
    )
  }

  return (
    <div className="outfit-grid">
      {outfits.map(outfit => (
        <OutfitCard
          key={outfit.id || outfit.tag}
          outfit={outfit}
          onClick={onItemClick}
          showDelete={showDelete}
          onDelete={onDelete}
          isSelected={selectedId === (outfit.id || outfit.tag)}
        />
      ))}
    </div>
  )
}

export default OutfitGrid
